import Navbar from "../../components/navbar/navbar";
import Sidebar from "../../components/sidebar/sidebar";


const PanelList = () => {
  return (
    <div className="home">
      <Sidebar />
      <div className="homeContainer">
        <Navbar />
        
      </div>
    </div>
  );
};

export default PanelList